import RegexUtils from './RegexUtils';

export const isDecimal = (arg) =>
  RegexUtils.isValid(arg, RegexUtils.regexes.decimalNumber);
